import React from 'react';
import homeGrayIcon from '/assets/images/homeGrayIcon.png';
import barIcon from '/assets/images/barIcon.png';
import unReportedIcon from '/assets/images/unReportedIcon.png';
import expenseIcon from '/assets/images/expenseIcon.png';
import settingIcon from '/assets/images/settingIcon.png';
import logoutIcon from '/assets/images/logoutIcon.png';
// unreportedBillIcon
import unreportedBillIcon from '/assets/images/unreportedBillIcon.png';
import report from '/assets/images/report.png';
import stpfcReport from '/assets/images/stpfcReport.png'
import leaveIcon from '../../src/assets/icons/leaveIcon.png'
import leaveIconGrey from '../../src/assets/icons/leaveIconGrey.png'
import leaveApproval from '../../src/assets/icons/leaveApproval.png'
import leaveApprovalGrey from '../../src/assets/icons/leaveApprovalGrey.png'

// const Home = lazy(() => import('../pages/home'));

const area = JSON.parse(localStorage.getItem('userData'))?.areaRange;

import {
  Home,
  Sfc,
  MyExpense,
  User,
  Setting,
  Logout,
  CameraOption,
  Notification,
  CapturedImage,
  CapturedDetails,
  UnReportedExpenses,
  CropImage,
  MyExpenseDetails,
  PageNotFound,
  Login,
  UploadBills,
  Stpfc,
  ExpenseApproval,
  ExpenseApprovaldetails,
  ExpenseReport,
  Sfcreport,
  ExpenseCreation,
  LeaveModule,
  LeaveApproval
} from '../pages/route';
import OtherExpenseApproval from '../pages/expenseApproval/OtherExpenseApproval';

export const routersConfig = [
  // { path: '/', element: <Login />},
  // { path: '/login', element: <Login />},
  // { path: '/home', element: <Home />},
  { path: '/sfc', element: <Sfc /> },
  { path: '/my-expense', element: <MyExpense /> },
  { path: '/my-expense/:monthId', element: <MyExpense /> },
  { path: '/expense-creation', element: <ExpenseCreation /> },
  { path: '/other-expense', element: <OtherExpenseApproval/> },
  { path: '/expense-creation/:expenseDetailId', element: <ExpenseCreation /> },
  { path: '/user', element: <User /> },
  { path: '/setting', element: <Setting /> },
  { path: '/logout', element: <Logout /> },
  { path: '/camera', element: <CameraOption /> },
  { path: '/notification', element: <Notification /> },
  { path: '/capture-image', element: <CapturedImage /> },
  { path: '/captured-image-details', element: <CapturedDetails /> },
  { path: '/crop-image', element: <CropImage /> },
  { path: '/un-reported-expenses', element: <UnReportedExpenses /> },
  { path: '/my-expense-details', element: <MyExpenseDetails /> },
  {
    path: '/my-expense-details/:expenseDetailId',
    element: <MyExpenseDetails />,
  },

  // Desktop
  { path: '/upload-bills', element: <UploadBills /> },
  { path: '/stpfc-approval', element: <Stpfc /> },
  { path: '/expense-approval', element: <ExpenseApproval /> },
  { path: '/expense-details/:expenseId', element: <ExpenseApprovaldetails /> },
  { path: '/expense-report', element: <ExpenseReport /> },
  { path: '/stpfc-report', element: <Sfcreport /> },
  { path: '/LeaveModule', element: <LeaveModule /> },
  { path: '/LeaveApproval', element: <LeaveApproval /> },

  // {
  //   path: '/expense-report',
  //   element: <ExpenseReport />,
  //   icon: report,
  //   name: 'Expense Reports',
  // },
  // {
  //   path: '/stpfc-report',
  //   element: <Sfcreport />,
  //   icon: report,
  //   name: 'STPFC Reports',
  // },
  // // Page Not Found
  { path: '*', element: <PageNotFound /> },
];

//side bar
export const sideBarConfig = [
  { path: '/home', element: <Home />, icon: homeGrayIcon, name: 'Home' },
  {
    path: '/sfc',
    element: <Sfc />,
    icon: barIcon,
    name: 'Standard Fare Chart',
  },
  {
    path: '/my-expense',
    element: <UnReportedExpenses />,
    icon: expenseIcon,
    name: 'My Expense',
  },
  {
    path: '/un-reported-expenses',
    element: <MyExpense />,
    icon: unreportedBillIcon,
    name: 'Unreported Bills',
  },
  {
    path: '/setting',
    element: <Setting />,
    icon: settingIcon,
    name: 'Setting',
  },
    {
    path: '/LeaveModule',
    element: <LeaveModule />,
    icon: leaveIcon,
    name: 'Leave',
  },

  {
    path: '/LeaveApproval',
    element: <LeaveApproval />,
    icon: leaveApproval,
    name: 'Leave Approval',
  },
  { path: '/logout', element: <Logout />, icon: logoutIcon, name: 'Logout' },
  // {
  //   path: '/expense-report',
  //   element: <ExpenseReport />,
  //   icon: report,
  //   name: 'Expense Report',
  // },
  // {
  //   path: '/stpfc-report',
  //   element: <Sfcreport />,
  //   icon: stpfcReport,
  //   name: 'STPFC Reports',
  // },
];

// export  {routersConfig,sideBarConfig};
